<template>
  <nav
    id="leftMenu"
    :class="
      'navbar navbar-expand-md fixed-left text-center bg-dark navbar-dark' +
        (showMenuTitle ? '' : ' toogled')
    "
  >
    <a class="navbar-brand text-center d-block mx-auto mb-4 pt-3" href="/"
      ><img
        class="mx-auto d-block"
        id="imgLeft"
        :src="'/img/' + this.partner.code + '/logo_sidebar.png'"
    /></a>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#leftMenu"
      aria-controls="leftMenu"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div
      class="collapse navbar-collapse"
      v-if="menuLeft && menuLeft.length > 0"
    >
      <ul class="navbar-nav">
        <router-link
          v-for="ml in menuLeft"
          :key="ml.id"
          :to="ml.routeUrl"
          v-slot="{ href, route, navigate, isActive, isExactActive }"
        >
          <li
            :class="[
              'nav-item',
              isExactActive && 'active exact_active',
              isActive && 'active',
            ]"
            :id="ml.id"
          >
            <a
              :class="[
                'nav-link',
                isExactActive && 'active exact_active',
                isActive && 'active',
              ]"
              :href="href"
              @click="navigate"
              :id="ml.id + '_link'"
              ><i
                ><img :src="require('../assets/img/ICOS/' + ml.id + '.svg')"
              /></i>
              <span v-if="showMenuTitle">{{ $i18n.t(ml.title) }}</span>
              <span class="badge ml-2 badge-gold" :id="ml.id + '_badge'"></span
            ></a>
          </li>
        </router-link>
      </ul>
    </div>
    <div class="bottom_menu collapse navbar-collapse">
      <ul class="navbar-nav">
        <!--<li class="nav-item">
              <a href="javascript:void(0)" v-on:click="changeLang">{{$t("changer_langue")}}</a>
          </li>-->
        <li class="nav-item">
          <router-link
            key="profil"
            to="/profil"
            v-slot="{ href, route, navigate, isActive, isExactActive }"
          >
            <a :href="href" @click="navigate" id="profil_link" class="nav-link"
              ><i class="material-icons">receipt_long</i>
              <span v-if="showMenuTitle">{{ $i18n.t("Mon profil") }}</span></a
            >
          </router-link>
        </li>
        <li class="nav-item">
          <a
            class="toggleMenu nav-link"
            href="javascript:void(0)"
            @click="toggleMenu"
            ><i class="material-icons" v-if="showMenuTitle">arrow_back</i
            ><i class="material-icons" v-else>arrow_forward</i>
            <span v-if="showMenuTitle">Réduire le menu</span></a
          >
        </li>
        <li class="nav-item">
          <router-link
            key="deconnexion"
            to="/logout"
            v-slot="{ href, route, navigate, isActive, isExactActive }"
          >
            <a
              :href="href"
              @click="navigate"
              id="deconnexion_link"
              class="nav-link"
              ><i class="material-icons">logout</i>
              <span v-if="showMenuTitle">{{ $i18n.t("Déconnexion") }}</span></a
            >
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: "RwvNavMenu",
  data() {
    return {
      showMenuTitle: 1,
      menuLeft: [],
    };
  },
  methods: {
    toggleMenu() {
      this.showMenuTitle = !this.showMenuTitle;
      if (this.showMenuTitle) {
        document.getElementById("body").classList.remove("mini-nav");
      } else {
        document.getElementById("body").classList.add("mini-nav");
      }
    },
    loadMenu() {
      var p = this;
      window.setTimeout(function() {
        p.get_infos_cli();
        if (p.infos_cli && p.infos_cli.menu && p.infos_cli.menu.length > 0) {
          p.menuLeft = p.infos_cli.menu;
          if (p.menuLeft.length == 3 && p.$route.path == "/") {
            p.$router.push({ path: p.menuLeft[0].routeUrl });
          }
        } else p.loadMenu();
      }, 1000);
    },
  },
  mounted() {
    this.maj_partner();
    this.loadMenu();
  },
};
</script>
